export default __webpack_public_path__ + "app/images/b8833d26283fa23a81177a6daaa297e7.svg";